<template>
  <div class="entry-info entry-info-more">
    <!-- 新建报名展示赛事信息；已有报名（查看/编辑）不展示顶部 -->
    <div class="title-info" v-if="project.unionMatchId && !teamId">
      <div class="title-info-logo">
        <img :src="imageView(project.icon)" alt="">
      </div>
      <div class="title-info-right">
        <div class="row row-name">{{ match.chineseName || project.unionMatchName || project.chineseName || '-' }}</div>
        <div class="row row-group">组别：{{ project.matchGroupName || '-' }}</div>
        <div class="row">
          允许队员人数：{{ project.teamMemberLeastCount ?? 0 }} ～ {{ project.teamMemberLimitCount ?? 0 }}
        </div>
        <div class="row" v-if="project.genderLimit !== 3">
          允许性别：{{ project.genderLimit === 1 ? '男' : project.genderLimit === 2 ? '女' : '混合' }}
        </div>
        <div class="row" v-if="project.isOpenAgeLimit === 1">
          参赛年龄：{{ getFormatDate(project.maxAge) }}
          {{ project.maxAge && project.minAge ? ' ~ ' : '' }}
          {{ getFormatDate(project.minAge) }}
        </div>
        <div class="row row-fee" v-if="project.feeMethod !== 0">
          收费方式：{{ getFeeMethodsLabel(project.feeMethod) }} 金额：{{ project.feeAmount != null ? (project.feeAmount / 100).toFixed(2) : '0.00' }}元/{{ feeUnitText }}
        </div>
        <div class="row" v-if="project.feeMethod !== 0 && project.feeDescription">
          收费说明：{{ project.feeDescription }}
        </div>
      </div>
    </div>
    <div
      v-if="!teamId && (project.signupInstructionsOpen === 1 || project.signupInstructionsOpen === 2) && signupInstructions"
      class="signup-notice-bar"
      @click="signupInstructionsOpen = true"
    >
      <van-icon name="volume-o" class="notice-icon" />
      <span class="notice-text" :title="signupInstructionsText">{{ signupInstructionsText || '报名须知' }}</span>
      <span class="notice-link">查看详情 &gt;</span>
    </div>
    <div class="entry-more-main">
      <div class="person-detail-header">
        <span class="person-detail-title">报名资料</span>
        <van-button
          v-if="teamId && canEditPersonal && !isEditing"
          class="person-detail-edit-btn"
          size="small"
          type="primary"
          plain
          @click="goEdit"
        >
          编辑
        </van-button>
      </div>
      <div ref="tabGuideAnchor" class="player-tabs-custom" v-if="players.length">
        <div
          v-for="(p, idx) in players"
          :key="'tab-' + idx"
          class="player-tabs-item"
          :class="{ 'is-active': activeTab === idx }"
          :style="{ '--tab-accent': tabsAccentColor }"
          @click="selectPlayerTab(idx)"
        >
          <span class="player-tabs-label">选手{{ idx + 1 }}</span>
        </div>
      </div>
      <!-- 每位选手独立 PlayerForm + v-show，避免切换 Tab 时单一子组件用旧 props 覆盖已填数据 -->
      <div
        v-for="(p, idx) in players"
        v-show="activeTab === idx"
        :key="'player-form-' + idx"
        class="player-form-wrap"
      >
        <PlayerForm
          ref="playerForm"
          hide-personal-title
          :form-readonly="formReadonly"
          :form.sync="players[idx]"
          :player-signup-fields="psfs"
          :jerseys-size-fields="project.jerseysSizeFields || ''"
          :jerseys-size-accessory="project.jerseysSizeAccessory || ''"
          :player-number-range="project.playerNumberRange"
          :cert-type-columns="certTypeColumns"
          :player-signup-fields-label="playerSignupFieldsLabel"
          :sport-type="project.sportType"
          :max-age="project.maxAge"
          :min-age="project.minAge"
          :qiniu-token="qiniuToken"
          :gender-limit="project.genderLimit"
          :custom-text-options="project.customTextOptions"
        />
      </div>
    </div>
    <div v-if="!teamId && project.signupExplanation" class="bottom-explanation">
      <div class="bottom-explanation-title">说明</div>
      <div class="bottom-explanation-content" v-html="signupExplanationHtml"></div>
    </div>
    <div v-if="showButton && showBottomBar && !teamId" class="bottom">
      <div @click="showAgreementFun" v-if="project.isUseAgreement === 1 && agreementList.length > 0"
        style="display: flex; justify-content: center; padding: 0 0 8px 0">
        <van-checkbox disabled v-model="allow" shape="square" icon-size="16px">
          <span style="font-size: 13px; color: #8C8C8C">报名前请先同意</span>
          <span v-for="item in agreementList" :key="item.id" style="color: #409EFF; font-size: 13px;">《{{ item.title
          }}》</span>
        </van-checkbox>
      </div>
      <van-button
        type="info"
        block
        @click="savePlayers"
        :style="{ 'background-color': jetlympic ? '#00A7FF' : 'var(--bg3)' }"
        style="border: none; color: #FFFFFF; height: 50px; border-radius: 25px"
      >创建报名资料</van-button>
    </div>
    <div class="bottom-actions" v-else-if="showButton && showBottomBar && teamId">
      <van-button
        class="bottom-btn"
        type="info"
        @click="updatePlayers"
        :style="{ 'background-color': jetlympic ? '#00A7FF' : '#509DEA' }"
      >保存</van-button>
    </div>
    <div class="popup">
      <van-popup v-model="showAgreement" position="bottom" round :style="{ height: '70%' }">
        <div id="agreement"></div>
        <div style="height: 115px;"></div>
        <div class="bottom">
          <van-button type="info" block @click="allowAgreement"
            :style="{ 'background-color': jetlympic ? '#00A7FF' : '#191919' }" style="border: none; color: #FFFFFF; height: 50px; border-radius: 25px">同意条款</van-button>
        </div>
      </van-popup>
    </div>
    <van-overlay :show="showLoading">
      <div class="wrapper">
        <van-loading color="#1989fa" size="30" />
      </div>
    </van-overlay>
    <van-dialog
      v-model="showCreateSuccessDialog"
      class-name="entry-more-create-success-dialog"
      :show-cancel-button="false"
      confirm-button-text="确定"
      :confirm-button-color="createSuccessConfirmColor"
      @confirm="onCreateSuccessConfirm"
    >
      <div class="entry-more-create-success-body">
        <p class="entry-more-create-success-title">资料创建成功</p>
        <p class="entry-more-create-success-sub">查看报名表</p>
      </div>
    </van-dialog>
    <van-popup v-model="signupInstructionsOpen" :close-on-click-overlay="false"
      :style="{ width: '80%', 'border-radius': '4px' }">
      <div class="notice">
        <div class="notice-title">报名须知</div>
        <div class="info" v-html="signupInstructions"></div>
        <div class="close" :class="{ 'disabled': time > 0 }" @click="closeNotice">
          我知道了 <span v-if="time > 0">({{ time }})</span>
        </div>
      </div>
    </van-popup>

    <!-- 新建报名：选手 Tab 蒙层引导（双打/多人切换录入） -->
    <div v-if="showTabGuide && tabGuideRect" class="tab-guide-root">
      <div class="tab-guide-strip tab-guide-strip--top" :style="tabGuideStripTopStyle" @click.stop />
      <div class="tab-guide-strip tab-guide-strip--bottom" :style="tabGuideStripBottomStyle" @click.stop />
      <div class="tab-guide-strip tab-guide-strip--left" :style="tabGuideStripLeftStyle" @click.stop />
      <div class="tab-guide-strip tab-guide-strip--right" :style="tabGuideStripRightStyle" @click.stop />
      <div class="tab-guide-connector" :style="tabGuideConnectorStyle" aria-hidden="true" />
      <div
        class="tab-guide-bubble"
        :style="[tabGuideBubbleWrapStyle, { background: tabGuideBubbleBg }]"
      >
        <p class="tab-guide-bubble-text">报名双打项目，切换队员录入第二名参赛选手</p>
        <button
          type="button"
          class="tab-guide-bubble-btn"
          :style="{ color: tabGuideBtnColor }"
          @click="dismissTabGuide"
        >
          我知道了
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import {
  Form, Field, Icon, Popup, Checkbox, Loading, Overlay, Dialog,
  Toast, Button
} from 'vant'
import { DateUtil, QNImageUtil } from '@/utils'
import { getQiniuUploadToken } from '@/api/qiniu'
import {
  createBMMatchGroupTeam,
  getAreaTreeList,
  getBMMatchTeamSignup,
  getBMUnionMatch,
  updateBMMatchGroupTeam
} from '@/api/match'
import { getPassport } from '@/libs/passport'
import { feeMethodOptions, playerSignupFieldsLabel } from '@/config'
import PlayerForm from '@/components/PlayerForm'
import Cookies from 'js-cookie'

Vue.use(Form).use(Field).use(Icon).use(Popup).use(Checkbox)
  .use(Loading).use(Overlay).use(Dialog).use(Button).use(Toast)

const certTypeOption = [
  { value: 1, label: '身份证' },
  { value: 11, label: '学籍卡' },
  { value: 2, label: '护照' },
  { value: 3, label: '港澳通行证' },
  { value: 4, label: '台胞证' },
  { value: 5, label: '港澳台回乡证' }
]

export default {
  components: { PlayerForm },
  data() {
    return {
      certTypeColumns: certTypeOption,
      unionMatchId: '',
      match: {},
      projectId: '',
      teamId: '',
      team: {},
      project: {},
      players: [],
      psfs: [],
      activeTab: 0,
      allow: false,
      showLoading: false,
      showCreateSuccessDialog: false,
      /** CreateBMMatchGroupTeam 返回的球队 id，用于跳转 entry-info */
      createdTeamId: '',
      qiniuToken: '',
      options: [],
      playerCheckboxes: {},
      agreementList: [],
      showAgreement: false,
      showButton: false,
      signupInstructionsOpen: false,
      time: 5,
      signupInstructions: '',
      playerSignupFieldsLabel,
      isEditing: true,
      jetlympic: false,
      /** 新建报名：选手 Tab 蒙层引导 */
      showTabGuide: false,
      tabGuideRect: null,
      tabGuideViewport: { w: 0, h: 0 },
      tabGuideRetryCount: 0,
      /** 报名须知「我知道了」倒计时 interval，组件销毁时清理 */
      signupNoticeCountdownTimer: null
    }
  },
  computed: {
    /** 组合报名页展示与赛制一致的「元/组」 */
    feeUnitText() {
      return '组'
    },
    tabsAccentColor() {
      return this.jetlympic ? '#00A7FF' : '#E20013'
    },
    createSuccessConfirmColor() {
      return this.jetlympic ? '#00A7FF' : '#576b95'
    },
    canEditPersonal() {
      const t = this.team
      if (!this.teamId || !t || Object.keys(t).length === 0) return false
      return t.isSubmit === 0 || t.auditStatus === -1
    },
    formReadonly() {
      return !!(this.teamId && !this.isEditing)
    },
    showBottomBar() {
      if (!this.teamId) return true
      return this.isEditing
    },
    signupExplanationHtml() {
      const text = (this.project && this.project.signupExplanation) || ''
      return text ? text.replace(/\n/g, '<br/>') : ''
    },
    signupInstructionsText() {
      if (!this.signupInstructions) return ''
      if (typeof document === 'undefined') return ''
      const div = document.createElement('div')
      div.innerHTML = this.signupInstructions
      return (div.textContent || div.innerText || '').trim()
    },
    tabGuideStripTopStyle() {
      const r = this.tabGuideRect
      if (!r) return {}
      return { top: '0', left: '0', width: '100%', height: `${r.top}px` }
    },
    tabGuideStripBottomStyle() {
      const r = this.tabGuideRect
      const v = this.tabGuideViewport
      if (!r || !v.h) return {}
      const h = Math.max(0, v.h - r.top - r.height)
      return { top: `${r.top + r.height}px`, left: '0', width: '100%', height: `${h}px` }
    },
    tabGuideStripLeftStyle() {
      const r = this.tabGuideRect
      if (!r) return {}
      return { top: `${r.top}px`, left: '0', width: `${r.left}px`, height: `${r.height}px` }
    },
    tabGuideStripRightStyle() {
      const r = this.tabGuideRect
      const v = this.tabGuideViewport
      if (!r || !v.w) return {}
      const w = Math.max(0, v.w - r.left - r.width)
      return {
        top: `${r.top}px`,
        left: `${r.left + r.width}px`,
        width: `${w}px`,
        height: `${r.height}px`
      }
    },
    tabGuideConnectorStyle() {
      const r = this.tabGuideRect
      if (!r) return {}
      const lineH = 20
      const cx = r.left + r.width / 2
      return {
        position: 'fixed',
        left: `${cx - 1}px`,
        top: `${r.top + r.height}px`,
        width: '2px',
        height: `${lineH}px`,
        zIndex: 10001,
        pointerEvents: 'none'
      }
    },
    tabGuideBubbleWrapStyle() {
      const r = this.tabGuideRect
      if (!r) return {}
      const lineH = 20
      return {
        position: 'fixed',
        top: `${r.top + r.height + lineH}px`,
        left: '50%',
        transform: 'translateX(-50%)',
        width: 'calc(100vw - 32px)',
        maxWidth: '320px',
        zIndex: 10001
      }
    },
    tabGuideBubbleBg() {
      return this.jetlympic ? '#00A7FF' : '#1989fa'
    },
    tabGuideBtnColor() {
      return this.jetlympic ? '#00A7FF' : '#1989fa'
    }
  },
  watch: {
    signupInstructionsOpen(val, oldVal) {
      if (oldVal === true && val === false) {
        if (this.signupNoticeCountdownTimer) {
          clearInterval(this.signupNoticeCountdownTimer)
          this.signupNoticeCountdownTimer = null
        }
        this.$nextTick(() => setTimeout(() => this.tryShowTabGuide(), 120))
      }
    }
  },
  mounted() {
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', this.onTabGuideResize)
      window.addEventListener('orientationchange', this.onTabGuideResize)
    }
    if (window.localStorage.getItem('jetlympic')) {
      this.jetlympic = true
    }
    getPassport().then(res => {
      if (res) {
        this.unionMatchId = this.$route.query.unionMatchId
        this.projectId = this.$route.query.matchId
        this.teamId = this.$route.query.teamId || ''
        this.getBMUnionMatch()
        this.getQiniuUploadToken()
        this.getAreaTreeList()
      }
    })
  },
  beforeDestroy() {
    if (this.signupNoticeCountdownTimer) {
      clearInterval(this.signupNoticeCountdownTimer)
      this.signupNoticeCountdownTimer = null
    }
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.onTabGuideResize)
      window.removeEventListener('orientationchange', this.onTabGuideResize)
    }
  },
  methods: {
    imageView(img) {
      if (!img) return ''
      return QNImageUtil.imageView(img)
    },
    goEdit() {
      if (!this.canEditPersonal) return
      this.isEditing = true
      this.getQiniuUploadToken()
    },
    onTabChange() {
      this.$nextTick(() => {
        const el = this.$el && this.$el.querySelector && this.$el.querySelector('.player-form-wrap')
        if (el) el.scrollTop = 0
      })
    },
    selectPlayerTab(idx) {
      if (idx === this.activeTab) return
      this.activeTab = idx
      this.onTabChange()
    },
    updateTabGuideViewport() {
      if (typeof window === 'undefined') return
      this.tabGuideViewport = { w: window.innerWidth, h: window.innerHeight }
    },
    measureTabGuideRect() {
      const el = this.$refs.tabGuideAnchor
      if (!el) return null
      const rect = el.getBoundingClientRect()
      return {
        top: rect.top,
        left: rect.left,
        width: rect.width,
        height: rect.height
      }
    },
    tryShowTabGuide() {
      if (this.teamId) return
      if (!this.players || this.players.length < 2) return
      if (this.signupInstructionsOpen) return
      this.$nextTick(() => {
        requestAnimationFrame(() => {
          this.updateTabGuideViewport()
          const r = this.measureTabGuideRect()
          if (!r || r.width < 4 || r.height < 4) {
            if (this.tabGuideRetryCount < 8) {
              this.tabGuideRetryCount += 1
              setTimeout(() => this.tryShowTabGuide(), 400)
            }
            return
          }
          this.tabGuideRetryCount = 0
          this.tabGuideRect = r
          this.showTabGuide = true
        })
      })
    },
    dismissTabGuide() {
      this.showTabGuide = false
      this.tabGuideRect = null
    },
    onTabGuideResize() {
      if (!this.showTabGuide) return
      this.updateTabGuideViewport()
      const r = this.measureTabGuideRect()
      if (r) this.tabGuideRect = r
    },
    /** 将各 PlayerForm 内部 formData 写回 players，保证提交/校验用的是最新输入（含未 emit 的 van-field） */
    syncPlayersFromRefs() {
      const refs = this.$refs.playerForm
      if (!refs) return
      const list = Array.isArray(refs) ? refs : [refs]
      list.forEach((comp, i) => {
        if (!comp || typeof comp.getFormData !== 'function') return
        const data = comp.getFormData()
        const prev = this.players[i] || {}
        this.$set(this.players, i, { ...prev, ...data })
      })
    },
    closeNotice() {
      if (this.time <= 0) {
        if (this.signupNoticeCountdownTimer) {
          clearInterval(this.signupNoticeCountdownTimer)
          this.signupNoticeCountdownTimer = null
        }
        this.signupInstructionsOpen = false
        Cookies.set(this.projectId, this.projectId)
      }
    },
    getFeeMethodsLabel(value) {
      const item = feeMethodOptions.find(f => f.value === value)
      if (!item) return '--'
      return item.label
    },
    allowAgreement() {
      this.allow = true
      this.showAgreement = false
    },
    showAgreementFun() {
      this.showAgreement = true
      setTimeout(() => {
        const agreement = document.getElementById('agreement')
        if (!agreement) return
        let inner = ''
        this.agreementList.forEach(a => {
          inner += `<div style="background-color: #fff; padding: 12px 12px 0 12px;text-align: center;font-weight: 600;font-size: 24px;margin-bottom: 4px;">${a.title}</div>`
          inner += a.content
        })
        agreement.innerHTML = inner
      }, 0)
    },
    getAreaTreeList() {
      getAreaTreeList().then(res => {
        if (res) {
          const { data } = res
          this.options = JSON.parse(data.list.list.replaceAll("'", '"')) || []
          this.getBMMatchTeamSignup()
        }
      })
    },
    checkPlayer(player) {
      let result = true
      const psfs = this.project.playerSignupFields && this.project.playerSignupFields.split('|') || []
      psfs.forEach(psf => {
        if (psf === 'IDCard' && (!player.certType || !player.IDCardNo)) {
          result = false
        } else if (psf === 'ID' && (!player.IDCardPhotoA || !player.IDCardPhotoB)) {
          result = false
        } else if (psf === 'guardian' && (!player.guardianName || !player.guardianMobile)) {
          result = false
        } else if (psf !== 'IDCard' && psf !== 'ID' && !player[psf]) {
          result = false
        }
      })
      return result
    },
    normalizePlayerRow(player) {
      if (!player) return
      player.bmBirthdayValue = player.bmBirthday && this.getFormatDate(player.bmBirthday) || ''
      const cols = this.certTypeColumns && this.certTypeColumns.length ? this.certTypeColumns : certTypeOption
      const label = cols.find(i => i.value === player.certType)
      player.certTypeValue = label ? label.label : '身份证'
      if (player.certTypeValue === '身份证') {
        player.certType = 1
      }
      player.avatarList = player.avatar && [{ url: QNImageUtil.imageView(player.avatar), isImage: true }] || []
      player.IDCardPhotoAList = player.IDCardPhotoA && [{ url: QNImageUtil.imageView(player.IDCardPhotoA), isImage: true, hash: player.IDCardPhotoA }] || []
      player.IDCardPhotoBList = player.IDCardPhotoB && [{ url: QNImageUtil.imageView(player.IDCardPhotoB), isImage: true, hash: player.IDCardPhotoB }] || []
      if (player.qualificationFile && player.qualificationFile.length > 0) {
        const a = player.qualificationFile.split(',') || []
        player.qualificationFileList = []
        a.forEach(item => {
          player.qualificationFileList.push({ url: QNImageUtil.imageView(item), isImage: true, hash: item })
        })
      } else {
        player.qualificationFileList = []
      }
      if (player.insureFile && player.insureFile.length > 0) {
        const a = player.insureFile.split(',') || []
        player.insureFileList = []
        a.forEach(item => {
          player.insureFileList.push({ url: QNImageUtil.imageView(item), isImage: true, hash: item })
        })
      } else {
        player.insureFileList = []
      }
      const a = []
      this.getAreaInfo(player.domicileAreaId, this.options, a)
      a.reverse()
      player.domicileAreaName = a.join('/')
    },
    getBMMatchTeamSignup() {
      const params = {
        matchId: this.projectId
      }
      if (this.teamId) {
        params.teamId = this.teamId
      }
      getBMMatchTeamSignup(params).then(res => {
        if (res) {
          const data = res.data || {}
          if (!data.team) {
            this.showButton = true
          } else if (data.team.isSubmit === 1 && data.team.auditStatus !== -1) {
            this.showButton = false
          } else if (data.team.auditStatus != 2) {
            this.showButton = data.team.auditStatus != 2
          }
          if (data.match.playerSignupFieldsLabel) {
            this.playerSignupFieldsLabel = {
              ...this.playerSignupFieldsLabel,
              ...data.match.playerSignupFieldsLabel
            }
          }
          const project = data.match
          this.agreementList = data.agreement || []
          this.minDate = project.maxAge ? new Date(project.maxAge) : new Date(1970, 0, 1)
          this.maxDate = project.minAge ? new Date(project.minAge) : new Date()
          if (project.certTypeFields && project.certTypeFields.length) {
            this.certTypeColumns = certTypeOption.filter(
              item => project.certTypeFields.indexOf(item.value) > -1
            )
          } else {
            this.certTypeColumns = [...certTypeOption]
          }
          const psfs = project.playerSignupFields && project.playerSignupFields.split('|') || []
          this.psfs = psfs
          const playerCheckboxes = {}
          psfs.forEach(psf => {
            playerCheckboxes[psf] = true
          })
          this.playerCheckboxes = playerCheckboxes
          this.project = data.match
          this.team = data.team || {}
          let players = data.players || []
          if (players.length === 0) {
            for (let i = 0; i < this.project.teamMemberLimitCount; i++) {
              players.push({ certType: 1 })
            }
          }
          players.forEach(p => {
            this.normalizePlayerRow(p)
            p.showPlayerInfo = this.checkPlayer(p)
          })
          if (project.signupInstructionsOpen === 1 || project.signupInstructionsOpen === 2) {
            this.signupInstructions = project.signupInstructions || ''
          } else {
            this.signupInstructions = ''
          }
          // 新建报名（无 teamId）且必须阅读：自动弹窗，与 entry-info 一致（不依赖 Cookie，避免他页已写 cookie 导致不弹）
          const o = project.signupInstructionsOpen
          const mustRead = o === 1 || o === '1'
          if (!this.teamId && mustRead) {
            if (this.signupNoticeCountdownTimer) {
              clearInterval(this.signupNoticeCountdownTimer)
              this.signupNoticeCountdownTimer = null
            }
            this.time = 5
            this.signupInstructionsOpen = true
            this.signupNoticeCountdownTimer = setInterval(() => {
              this.time--
              if (this.time <= 0) {
                clearInterval(this.signupNoticeCountdownTimer)
                this.signupNoticeCountdownTimer = null
              }
            }, 1000)
          }
          this.players = players
          this.activeTab = 0
          this.isEditing = !this.teamId
          this.$nextTick(() => {
            setTimeout(() => this.tryShowTabGuide(), 120)
          })
        }
      })
    },
    getBMUnionMatch() {
      const params = {
        unionMatchId: this.unionMatchId
      }
      getBMUnionMatch(params).then(res => {
        if (res) {
          const { data } = res
          this.match = data.match || {}
        }
      })
    },
    getFormatDate(date) {
      if (!date) return ''
      return DateUtil.parseDateTime(date, '{y}-{m}-{d}')
    },
    getQiniuUploadToken() {
      getQiniuUploadToken({}).then(res => {
        this.qiniuToken = res.data.token
      })
    },
    getAreaInfo(areaId, options, a) {
      if (!areaId) return ''
      for (let i = 0; i < options.length; i++) {
        if (options[i].id === areaId) {
          a.push(options[i].name)
          return true
        } else if (options[i].kids) {
          const b = this.getAreaInfo(areaId, options[i].kids, a)
          if (b) {
            a.push(options[i].name)
            return true
          }
        }
      }
      return false
    },
    async validateAllPlayers() {
      this.syncPlayersFromRefs()
      const n = this.players.length
      const refs = this.$refs.playerForm
      const list = Array.isArray(refs) ? refs : refs ? [refs] : []
      for (let i = 0; i < n; i++) {
        this.activeTab = i
        await this.$nextTick()
        const pf = list[i]
        if (pf && pf.validate) {
          await pf.validate()
        }
      }
    },
    async savePlayers() {
      if (this.project.isUseAgreement === 1 && this.agreementList.length > 0 && !this.allow) {
        Toast.fail('请先同意协议或条款')
        return
      }
      try {
        await this.validateAllPlayers()
      } catch (e) {
        Toast.fail('请先完善选手信息')
        return
      }
      if (this.playerCheckboxes.gender) {
        const gl = this.project.genderLimit
        if (gl != null && gl !== 0 && gl !== 3) {
          const bad = this.players.some(p => p && p.gender != null && String(p.gender) !== String(gl))
          if (bad) {
            Toast({ type: 'fail', message: '性别异常' })
            return
          }
        }
      }
      const players = JSON.parse(JSON.stringify(this.players)) || []
      players.forEach(item => {
        delete item.avatarList
        delete item.IDCardPhotoAList
        delete item.IDCardPhotoBList
        delete item.qualificationFileList
        delete item.insureFileList
        delete item.showPlayerInfo
        delete item.domicileAreaName
        delete item.bmBirthdayValue
        delete item.certTypeValue
        delete item.agreementConfirmedCount
        delete item.quizCompletionRecordCount
      })
      const params = {
        matchId: this.projectId,
        players: JSON.stringify(players)
      }
      this.showLoading = true
      createBMMatchGroupTeam(params).then(res => {
        this.showLoading = false
        if (res) {
          const raw = res.data || {}
          this.createdTeamId = raw.id != null ? String(raw.id) : (raw.teamId != null ? String(raw.teamId) : '')
          this.showCreateSuccessDialog = true
        }
      }).catch(() => {
        this.showLoading = false
      })
    },
    async updatePlayers() {
      this.syncPlayersFromRefs()
      let checkInfo = true
      this.players.forEach(item => {
        if (!this.checkPlayer(item)) {
          checkInfo = false
        }
      })
      if (!checkInfo) {
        Toast.fail('请先完善球员信息')
        return
      }
      try {
        await this.validateAllPlayers()
      } catch (e) {
        Toast.fail('请先完善选手信息')
        return
      }
      if (this.playerCheckboxes.gender) {
        const gl = this.project.genderLimit
        if (gl != null && gl !== 0 && gl !== 3) {
          const bad = this.players.some(p => p && p.gender != null && String(p.gender) !== String(gl))
          if (bad) {
            Toast({ type: 'fail', message: '性别异常' })
            return
          }
        }
      }
      const players = JSON.parse(JSON.stringify(this.players)) || []
      players.forEach(item => {
        delete item.avatarList
        delete item.IDCardPhotoAList
        delete item.IDCardPhotoBList
        delete item.qualificationFileList
        delete item.insureFileList
        delete item.showPlayerInfo
        delete item.domicileAreaName
        delete item.bmBirthdayValue
        delete item.certTypeValue
        delete item.agreementConfirmedCount
        delete item.quizCompletionRecordCount
      })
      const params = {
        teamId: this.teamId,
        matchId: this.projectId,
        players: JSON.stringify(players)
      }
      this.showLoading = true
      updateBMMatchGroupTeam(params).then(res => {
        this.showLoading = false
        if (res) {
          Toast.success('保存成功')
          this.isEditing = false
          this.getBMMatchTeamSignup()
        }
      }).catch(() => {
        this.showLoading = false
      })
    },
    onCreateSuccessConfirm() {
      const teamId = this.createdTeamId || this.teamId || ''
      this.$router.push({
        path: '/entry-page/entry-info',
        query: {
          unionMatchId: this.unionMatchId,
          matchId: this.projectId,
          teamId
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.entry-info.entry-info-more {
  min-height: 100vh;
  background-color: rgb(246, 246, 248);
  padding-bottom: 120px;
  box-sizing: border-box;

  .title-info {
    display: flex;
    align-items: flex-start;
    padding: 16px;
    background-color: #fff;
    .title-info-logo {
      width: 42px;
      height: 42px;
      border-radius: 50%;
      overflow: hidden;
      flex-shrink: 0;
      background: #e8e8e8;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .title-info-right {
      flex: 1;
      min-width: 0;
      margin-left: 12px;
    }
    .row {
      font-size: 13px;
      color: #606266;
      line-height: 20px;
      margin-top: 6px;
      &:first-child {
        margin-top: 0;
      }
    }
    .row-name {
      font-size: 15px;
      font-weight: 600;
      color: #1d2129;
      line-height: 22px;
    }
    .row-group {
      color: #606266;
    }
    .row-fee {
      color: #606266;
    }
  }

  .signup-notice-bar {
    display: flex;
    align-items: center;
    padding: 12px 16px;
    background: #ffc60a;
    color: #000;
    font-size: 12px;
    cursor: pointer;
    .notice-icon {
      flex-shrink: 0;
      margin-right: 8px;
      font-size: 16px;
    }
    .notice-text {
      flex: 1;
      min-width: 0;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .notice-link {
      flex-shrink: 0;
      margin-left: 8px;
    }
  }

  .entry-more-main {
    margin: 0;
    background: #fff;
    overflow: hidden;
    padding-bottom: 8px;
  }

  .person-detail-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 6px 12px;
    height: 50px;
    box-sizing: border-box;
    background-color: #f6f6f8;
    border-bottom: 1px solid #ebedf0;
    .person-detail-title {
      font-size: 15px;
      font-weight: 500;
      color: #1d2129;
    }
    .person-detail-edit-btn {
      width: 68px;
      height: 30px;
      padding: 0;
      font-size: 13px;
      color: var(--bg3);
      background-color: #e9e9eb;
      border: none;
    }
  }

  /* 自定义选手 Tab：每项固定宽度 50px，文字居中；选中/未选中字号区分 */
  .player-tabs-custom {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-end;
    width: 100%;
    background: #fff;
    border-bottom: 1px solid #eceef2;
    box-sizing: border-box;
  }

  .player-tabs-item {
    flex: 0 0 80px;
    width: 80px;
    min-width: 80px;
    max-width: 80px;
    text-align: center;
    padding: 12px 0 10px;
    position: relative;
    box-sizing: border-box;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;

    .player-tabs-label {
      display: block;
      max-width: 100%;
      font-size: 14px;
      font-weight: 500;
      color: #86909c;
      line-height: 18px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    &.is-active .player-tabs-label {
      font-size: 16px;
      font-weight: 500;
      color: #1d2129;
    }

    &.is-active::after {
      content: '';
      position: absolute;
      left: 50%;
      bottom: 0;
      transform: translateX(-50%);
      width: 28px;
      height: 3px;
      border-radius: 2px;
      background: var(--tab-accent, #e20013);
    }
  }

  .player-form-wrap {
    background: #fff;
  }

  /* 新建报名：选手 Tab 蒙层引导 */
  .tab-guide-root {
    position: fixed;
    inset: 0;
    z-index: 10000;
    pointer-events: none;
  }

  .tab-guide-strip {
    position: fixed;
    background: rgba(0, 0, 0, 0.55);
    pointer-events: auto;
  }

  .tab-guide-connector {
    background: #fff;
    border-radius: 1px;
  }

  .tab-guide-bubble {
    pointer-events: auto;
    border-radius: 10px;
    padding: 16px 16px 14px;
    box-sizing: border-box;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
  }

  .tab-guide-bubble-text {
    margin: 0;
    font-size: 15px;
    line-height: 22px;
    color: #fff;
    text-align: left;
  }

  .tab-guide-bubble-btn {
    display: block;
    margin-top: 14px;
    margin-left: auto;
    padding: 7px 20px;
    font-size: 14px;
    font-weight: 500;
    background: #fff;
    border: none;
    border-radius: 999px;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
  }

  .bottom-explanation {
    padding: 12px 16px;
    background-color: #fff;
    border-top: 1px solid #ebedf0;
    margin-top: 0;
    .bottom-explanation-title {
      font-weight: bold;
      font-size: 15px;
      color: #1d2129;
      margin-bottom: 8px;
    }
    .bottom-explanation-content {
      font-size: 14px;
      color: #606266;
      line-height: 1.6;
      &::v-deep ul {
        margin: 0;
        padding-left: 20px;
      }
      &::v-deep li {
        margin-bottom: 4px;
      }
    }
  }

  .bottom {
    position: fixed;
    bottom: 0;
    width: 100vw;
    padding: 14px 12px 12px 12px;
    box-sizing: border-box;
    background-color: #ffffff;
  }

  .bottom-actions {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 12px 16px;
    padding-bottom: calc(12px + env(safe-area-inset-bottom));
    background: #fff;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
    display: flex;
    justify-content: flex-end;
    box-sizing: border-box;
    .bottom-btn {
      width: 132px;
      height: 50px;
      border: none;
      color: #ffffff;
      border-radius: 25px;
    }
  }

  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
}

.notice {
  .notice-title {
    text-align: center;
    font-size: 16px;
    padding: 12px 0;
  }
  .info {
    padding: 12px;
    white-space: pre-wrap;
  }
  .close {
    text-align: center;
    color: #576b95;
    padding: 12px 0;
  }
  .disabled {
    color: #999 !important;
  }
}

#agreement {
  padding: 0 24px 12px 24px;
  .wscnph {
    width: 100%;
  }
}

::v-deep .van-cell {
  min-height: 54px;
  box-sizing: border-box;
  align-items: center;
}
::v-deep .van-field__label {
  color: rgba(0, 0, 0, 0.9);
}
::v-deep .van-field__control {
  font-weight: 500;
}
</style>

<!-- van-dialog 挂载到 body，样式勿 scoped -->
<style lang="scss">
.entry-more-create-success-dialog {
  border-radius: 8px;
  overflow: hidden;

  .van-dialog__header {
    display: none;
  }

  .van-dialog__content {
    padding: 0 !important;
  }

  .van-dialog__footer {
    padding: 0;
  }

  .van-dialog__confirm {
    height: 50px;
    line-height: 50px;
    font-size: 16px;
    font-weight: 400;
  }

  .entry-more-create-success-body {
    padding: 28px 20px 22px;
    text-align: center;
  }

  .entry-more-create-success-title {
    margin: 0;
    font-size: 17px;
    font-weight: 600;
    color: #1d2129;
    line-height: 24px;
  }

  .entry-more-create-success-sub {
    margin: 10px 0 0;
    font-size: 15px;
    font-weight: 400;
    color: #1d2129;
    line-height: 22px;
  }
}
</style>
